module.exports = __webpack_public_path__ + "img/brand_facebook.eb727f06.svg";